import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@apollo/client/react'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Pagination from '@components/Pagination/Pagination'
import Search from '@components/pages/PaymentPlan/Search'
import Table from '@components/pages/PaymentPlan/ListTable'
import GET_PAYMENT_PLANS from '@graphql/queries/get-payment-plans'

function List() {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchFilters = Object.fromEntries(searchParams)
  const { data, loading, error, refetch } = useQuery(GET_PAYMENT_PLANS, {
    variables: { filters: searchFilters }
  })

  return (
    <>
      <PageHeading heading='Payment Plans' />

      {error ? (
        <Error error={error} />
      ) : (
        <>
          <Search
            refetch={refetch}
            searchFilters={searchFilters}
            setSearchParams={setSearchParams}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.paymentPlans?.metadata}
          />
          <Table
            totalCount={data?.paymentPlans?.metadata?.totalCount}
            paymentPlans={data?.paymentPlans?.collection || []}
            loading={loading}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.paymentPlans?.metadata}
          />
        </>
      )}
    </>
  )
}

export default List
